import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {header} from "./header";
import {audienceOverview_template} from "../components/templates/audienceOverview_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;
declare var page: any;

export class audienceOverview extends vnModule_knockoutJS{

    protected audienceOverview_template: audienceOverview_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected indicatorPerformance: DOMHighResTimeStamp;
    protected detailPerformance: DOMHighResTimeStamp;
    protected zoneHeader: vnAppZone | null;


    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'audienceOverview';
    }

    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Audience Overview');

        this.audienceOverview_template = new audienceOverview_template('audienceOverview', this.viewModel, this)
        this.template = this.audienceOverview_template;

        return [this.audienceOverview_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void{

        this.audienceOverview_template.buildDatePickerCalendar();
        this.audienceOverview_template.setGraphMetricsFilterItems();
        this.audienceOverview_template.setTableMetricsFilterItems();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void{

        this.loadingIn(this.audienceOverview_template.builtTemplate.querySelector("#report-results"));

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();

        let usrReq_url: string = '/api/audience_overview/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

        /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onFilterRequestReturn(req, obj): Function {

        return function() {

            if(req.request.readyState == 4) {
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    // Every 100 report loads, display the Plan upgrade promotion (to free plan accounts only)
                    obj.zoneHeader?.loadedModule.showPlanPromo();

                    obj.updateFilters(responseParsed);

                    obj.updateViewModelFromPath();

                    obj.getReportStatus();

                    obj.getSampledDates();

                    obj.getIndicatorsByDateData();

                    obj.getDetailedData();
                }
            }

            obj.loadingOut(obj.audienceOverview_template.builtTemplate.querySelector("#report-results"));
        }
    }

    public getReportStatus(): void {

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/audience_overview/reportStatus/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onReportStatusRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getReportStatus');
    }

    public getSampledDates(): void{

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/audience_overview/sampledDates/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onSampledDatesRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getSampledDates');
    }

    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any): void {

        this.audienceOverview_template.setDynamicFilters(responseParsed.dynamicFiltersData);
        this.audienceOverview_template.setBrandFilterItems(responseParsed.portfolios);
        this.audienceOverview_template.setDefaultDevices();
    }

    public resetIndicatorsData(): void {

        this.audienceOverview_template.clearTimelineAnnotatonData();

        this.audienceOverview_template.clearIndicatorData();
        this.audienceOverview_template.setIndicatorDataLoaded(false);

        this.audienceOverview_template.clearCompIndicatorData();
        this.audienceOverview_template.setCompIndicatorDataLoaded(false);

        this.loadingIn(this.audienceOverview_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);
    }

    public getIndicatorsByDateData(): void {

        this.resetIndicatorsData();

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/audience_overview/indicatorsByDate/get/';

        this.indicatorPerformance = performance.now();

        this.sendFilterCall(baseApiUrl, subViewModel, this.onIndicatorsByDateDataRequestReturn.bind(this, "dateRange"), XMLHttpRequestHandler_requestType.GET, 'getIndicatorsByDateData');

        if(this.audienceOverview_template.compRangeSelected()){

            this.getCompIndicatorsByDateData();
        }
    }

    public getCompIndicatorsByDateData(): void{

        this.loadingIn(this.audienceOverview_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/audience_overview/compIndicatorsByDate/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onIndicatorsByDateDataRequestReturn.bind(this, "compDateRange"), XMLHttpRequestHandler_requestType.GET, 'getCompIndicatorsByDateData');
    }

    public getDetailedData(resetPagination: boolean = true): void{

        if (resetPagination) {

            this.audienceOverview_template.getTemplateViewModel().pagination.pageNumber(1);
        }

        this.loadingIn(this.audienceOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"), true);

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/audience_overview/dimensionsByDate/get/';

        this.detailPerformance = performance.now();

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDetailedDataRequestReturn.bind(this, baseApiUrl, 'getDetailedData'), XMLHttpRequestHandler_requestType.GET, 'getDetailedData');
    }

    protected paginationOnPageClick(){

        this.getDetailedData(false);
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onReportStatusRequestReturn(req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateReportStatusData(responseParsed);

                }
            }
        }
    }

    protected onSampledDatesRequestReturn(req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateSampledDatesData(responseParsed);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                }
            }
        }
    }

    protected updateReportStatusData(responseParsed: any): void{

        this.audienceOverview_template.setReportStatusData(responseParsed.reportStatusData);
    }

    protected updateSampledDatesData(responseParsed: any): void{

        this.audienceOverview_template.setSampledDatesData(responseParsed.sampledDatesData);
    }

    public getListDataForCSV(): void{

        this.loadingIn(this.audienceOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();

        subViewModel['csvExport'] = true;

        let baseApiUrl = '/api/audience_overview/dimensionsByDate/get/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onCSVDataRequestReturn(req, obj){

        return function (){

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    obj.exportCsvData(responseParsed);
                }
            }

            obj.loadingOut(obj.audienceOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"));
        };
    }

    protected exportCsvData(exportData): void{

        this.audienceOverview_template.setCsvExportData(exportData);
        this.audienceOverview_template.exportCsvData();
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onIndicatorsByDateDataRequestReturn(rangeType, req, obj): Function{

        return function() {

            if(req.request.readyState == 4) {

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    if (rangeType == 'dateRange') {

                        obj.audienceOverview_template.setIndicatorDataLoaded(true);
                        obj.updateIndicatorsData(responseParsed);
                    } else {

                        obj.audienceOverview_template.setCompIndicatorDataLoaded(true);
                        obj.updateCompIndicatorsData(responseParsed);
                    }

                    // LOADING : ends
                    if(obj.audienceOverview_template.indicatorsAllDataLoaded()){

                        var endTime = performance.now()
                        //console.log(`Indicator took ${(endTime - obj.indicatorPerformance)/1000}`)

                        obj.audienceOverview_template.updateIndicatorsGraphData();
                    }
                }
            }

            obj.loadingOut(obj.audienceOverview_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onDetailedDataRequestReturn(baseApiUrl, callIdentifier, req, obj): Function{

        return function() {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.updateDetailedData(responseParsed);

                if (responseParsed.totalCount && responseParsed.totalPage) {

                    obj.setResultInfo(baseApiUrl, callIdentifier, responseParsed.totalCount, responseParsed.totalPage);
                    obj.audienceOverview_template.getTemplateViewModel().isResultsInfoEnabled(true);
                    obj.audienceOverview_template.getTemplateViewModel().isPaginationEnabled(true);
                } else {
                    obj.audienceOverview_template.getTemplateViewModel().isResultsInfoEnabled(false);
                    obj.audienceOverview_template.getTemplateViewModel().isPaginationEnabled(false);
                }

            });

            obj.loadingOut(obj.audienceOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"), true);
        }
    }

    protected updateDetailedData(responseParsed: any): void{

        if(this.audienceOverview_template.getTemplateViewModel().tableMetricFilter.selectedOption() == 'traffic'){

            this.updateDimensionsData(responseParsed.data);
        }else{
            this.updateBrandsData(responseParsed.data);
        }

        this.audienceOverview_template.updatePagination(responseParsed.totalCount);
    }
    protected updateIndicatorsData(responseParsed: any): void{

        this.audienceOverview_template.setIndicatorsData(responseParsed.indicatorsData);
        this.audienceOverview_template.setTimelineAnnotationsData(responseParsed.timelineAnnotationsData, 0);
    }

    protected updateCompIndicatorsData(responseParsed: any): void{

        this.audienceOverview_template.setCompIndicatorsData(responseParsed.indicatorsData);
        this.audienceOverview_template.setTimelineAnnotationsData(responseParsed.timelineAnnotationsData, 1);
    }

    protected updateDimensionsData(responseParsed: any): void{

        this.audienceOverview_template.setDimensionsData(responseParsed.tableData, responseParsed.totals);
    }

    protected updateBrandsData(responseParsed: any): void{

        this.audienceOverview_template.setBrandsData(responseParsed.brandHeaders, responseParsed.tableData, responseParsed.totals);
    }

     /**
     * Hook.
     *
     * Initiates data refresh.
     */
     public filterDropdownOnChange(element): void{

        if(element=='brandFilter'){

            this.getReportStatus();
            this.getIndicatorsByDateData();
            this.getDetailedData();
        }
    }

    protected filterDateOnChange(element) {

        this.audienceOverview_template.processCompareOptions();
        this.getReportStatus();
        this.getSampledDates();
        this.getIndicatorsByDateData();
        this.getDetailedData();
    }

    protected filterSimpleOnChange(){

        this.getReportStatus();
        this.getIndicatorsByDateData();
        this.getDetailedData();
    }

    protected filterMultipleSelectorOnChange(){

        this.getReportStatus();
        this.getIndicatorsByDateData();
        this.getDetailedData();
    }

    protected filterSingleGroupSelectorOnChange(element){

        this.getReportStatus();

        if (element=='compareFilter') {

            this.audienceOverview_template.processCompareOptions();
        }

        if (element!='tableMetricFilter') {

            this.getIndicatorsByDateData();
        }else {

            this.audienceOverview_template.updateViewMode();
        }

        this.getDetailedData();
    }

    /**
     * Hook.
     *
     * Cancels data request.
     */
    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
    }

    public getReportData(): void{

        this.getReportStatus();
        this.getIndicatorsByDateData();
        this.getDetailedData();

    }

    protected setResultInfo(baseApiUrl, callIdentifier, totalCount, totalPage){

        let callHdl = this.getXHRHdl(baseApiUrl, callIdentifier);

        let execTime = Math.round((new Date().getTime() - callHdl.requestStartTime)/1000*100)/100;
        this.audienceOverview_template.setResultPage(totalCount, totalPage, execTime);
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }
    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = this.audienceOverview_template.getViewModelForRequest();
        subViewModel['filters']['keyword'] = keyword;
        subViewModel['filters']['filterId'] = id;

        let usrReq_url = '/api/audience_overview/autoCompleteSuggestions/get/';

        let usrReq_callback;
        usrReq_callback = this.onGetMultipleAutoCompleteSuggestionsReturn.bind(this, id);

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSuggestionsReturn(filterId, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    (obj.audienceOverview_template.setDynamicAutoCompleteMultiSelectFilterItems(filterId, responseParsed.data));
                }
            });
        };

    }
}


// WEBPACK FOOTER //
// ./js/modules/audienceOverview.ts